module.exports = __webpack_public_path__ + "static/media/Freitag, 15-05-22 feat S Dope.6687b40f.ogg";